var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"tw-font-medium"},[_vm._v("\n    Speakers notes\n  ")]),_vm._v(" "),_c('SidebarTextArea',{attrs:{"initial-text":_vm.notesText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }